import React from 'react';
import styled from 'App/styled';
import { useHistory } from 'react-router-dom';
import { pages } from 'constants/urls';


const Wrapper = styled.div`
  display: flex;
  width: 100%;
  height: 70vh;
  background: #fff;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
  .title {
    ${({ theme }) => theme.typography.type241};
    line-height: 32px;
    color: #001325;
    margin-bottom: 10px;
  }
  .subtitle {
    ${({ theme }) => theme.typography.bodyLarge};
    color: #001325;
    margin-bottom: 10px;
  }
`;
const Container = styled.div`
  display: flex;
  width: 400px;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  z-index: 2;
`;

const Button = styled.button`
  background: ${props => props.theme.brandPrimary};
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 8px;
  width: 100%;
  cursor: pointer;
  ${({ theme }) => theme.typography.bodyLarge};
`;

const ResultBg = styled.span`
  position: absolute;
  width: 100%;
  left: 0;
  right: 0;
  background: white;
  height: 100%;
`;
const Image = styled.img`
  width: 264px;
  height: 198px;
  margin-bottom: 48px;
`;

function NoResults() {
  const history = useHistory();
  const text = 'Thanks for visiting our website!';
  const subtitle = 'We looked all over, but that page seems to have gotten away from us.';
  const btnText = 'Back to Home';
  const image = 'https://adn-static1.nykaa.com/media/listing/no-result.jpg';
  const handleHome = () => {
    history.push(pages.HOME);
  };
  return (
    <Wrapper>
      <ResultBg />
      <Container>
        <Image src={image} alt="no_result" />
        <div className="title">{text}</div>
        <div className="subtitle">{subtitle}</div>
        <Button onClick={handleHome}>{btnText}</Button>
      </Container>
    </Wrapper>
  );
}

export default NoResults;
